module.exports = __webpack_public_path__ + "img/22-1.d040e61b.png";